"use client";

import { createClient } from "@tilli-internal/auth/client";
import type { BaseTenantId } from "@tilli-internal/tenant-data";
import { Thumbmark } from "@thumbmarkjs/thumbmarkjs";
import { getEnv } from "../env";

const thumbmark = new Thumbmark({
  api_key: "26fb3e6e8af977dc511733e1419dfed7",
  logging: false,
  property_name_factory(name) {
    return `tx-next-${name}`;
  },
  cache_lifetime_in_ms: 60 * 60 * 6000, // 6 hours
});
export const authClient: ReturnType<typeof createClient> = createClient({
  appId: "tilliX",
  baseURL: getEnv().baseUrl,
  basePath: getEnv().authApiPath,
  cors: "cors",
  forcedTenantId: (() => {
    if (typeof window !== "undefined") {
      return (
        (window.document.documentElement.getAttribute(
          "data-tenant",
        ) as BaseTenantId) ?? undefined
      );
    }
    return;
  })(),
  thumbmark,
});
